// Template variable categories shared between email and SMS templates

export const VARIABLE_CATEGORIES = [
  {
    id: 'customer',
    label: 'Customer',
    variables: [
      { key: 'customer.name', label: 'Customer Name' },
      { key: 'customer.email', label: 'Email' },
      { key: 'customer.phone', label: 'Phone' }
    ]
  },
  {
    id: 'appointment',
    label: 'Appointment',
    variables: [
      { key: 'appointment.date', label: 'Event Date' },
      { key: 'appointment.time', label: 'Event Time' },
      { key: 'appointment.service_address', label: 'Service Address' },
      { key: 'appointment.service_type', label: 'Service Type' },
      { key: 'appointment.meeting_url', label: 'Meeting Link' },
      { key: 'appointment.zoom_meeting_url', label: 'Zoom Link' },
      { key: 'appointment.teams_meeting_url', label: 'Teams Link' }
    ]
  },
  {
    id: 'business',
    label: 'Business',
    variables: [
      { key: 'business.name', label: 'Business Name' },
      { key: 'business.phone', label: 'Phone' },
      { key: 'business.email', label: 'Email' },
      { key: 'business.initials', label: 'Initials' }
    ]
  },
  {
    id: 'invoice',
    label: 'Invoice',
    emailOnly: true,
    variables: [
      { key: 'invoice.invoice_number', label: 'Invoice Number' },
      { key: 'invoice.date', label: 'Invoice Date' },
      { key: 'invoice.due_date', label: 'Due Date' },
      { key: 'invoice.total_amount', label: 'Total Amount' },
      { key: 'invoice.subtotal', label: 'Subtotal' },
      { key: 'invoice.tax_amount', label: 'Tax' },
      { key: 'invoice.payment_url', label: 'Payment URL' }
    ]
  }
];

// Get variable label from key
export const getVariableLabelFromKey = (variableKey) => {
  for (const category of VARIABLE_CATEGORIES) {
    const variable = category.variables.find(v => v.key === variableKey);
    if (variable) return variable.label;
  }
  return variableKey;
};
